(function(){
"use strict";
var $=function(id){return document.getElementById(id);};

/* 1. THE HANGER — three hinges so the clothes hang instead of being
   printed on. Skew, never rotate: a skew pins the hinge line so the
   seams cannot pull apart. */
if(!window.matchMedia("(prefers-reduced-motion: reduce)").matches){
  var stage=$("stage"), hang=$("hanger"), asm=$("assembly"), pen=$("pendulum"), hem=$("hem");
  var rx=0,ry=0,tRx=0,tRy=0,sw=0,swV=0,sh=0,shV=0,hm=0,hmV=0,held=false,lastX=null,idle=0,last=performance.now();
  var clamp=function(v,m){return v<-m?-m:v>m?m:v;};
  (function frame(t){
    var dt=Math.min(2.5,(t-last)/16.667); last=t; var s=t/1000;
    rx+=(tRx-rx)*.1*dt; ry+=(tRy-ry)*.1*dt;
    hang.style.transform="rotateX("+rx.toFixed(2)+"deg) rotateY("+ry.toFixed(2)+"deg)";
    var calm=!held&&t-idle>1100;
    var air=calm?Math.sin(s*.52)*.62+Math.sin(s*.21)*.34:0;
    swV+=((-ry*.07+air*.5)-sw)*.06*dt; swV*=Math.pow(.895,dt); sw=clamp(sw+swV*dt,3.4);
    asm.style.transform="translateZ(52px) rotate("+sw.toFixed(3)+"deg)";
    shV+=((-ry*.16+air*1.15-sw*.5)-sh)*.038*dt; shV*=Math.pow(.938,dt); sh=clamp(sh+shV*dt,5.5);
    pen.style.transform="skewX("+sh.toFixed(3)+"deg)";
    hmV+=((sh*.85)-hm)*.026*dt; hmV*=Math.pow(.952,dt); hm=clamp(hm+hmV*dt,6);
    hem.style.transform="skewX("+hm.toFixed(3)+"deg)";
    requestAnimationFrame(frame);
  })(last);
  stage.addEventListener("pointermove",function(e){
    var r=stage.getBoundingClientRect();
    tRy=((e.clientX-r.left)/r.width-.5)*28;
    tRx=-((e.clientY-r.top)/r.height-.5)*20;
    if(lastX!==null){var p=clamp((e.clientX-lastX)*-.035,1.1); shV+=p; hmV+=p*.7;}
    lastX=e.clientX; held=true; idle=performance.now();
  });
  ["pointerleave","pointerup","pointercancel"].forEach(function(t){
    stage.addEventListener(t,function(){tRx=0;tRy=0;lastX=null;held=false;idle=performance.now();});
  });
  var prevG=null;
  function orient(e){
    if(e.gamma==null) return;
    tRy=clamp(e.gamma*.42,17); tRx=clamp((e.beta-42)*.26,12);
    if(prevG!==null){var p=clamp((e.gamma-prevG)*-.22,.9); shV+=p; hmV+=p*.7;}
    prevG=e.gamma; idle=performance.now();
  }

  /* iPhones will not release motion data without a user gesture, so the
     hint under the hanger is a real button rather than a caption. */
  var btn=$("tiltbtn");
  var needsTap = typeof DeviceOrientationEvent!=="undefined"
              && typeof DeviceOrientationEvent.requestPermission==="function";
  var hasGyro = typeof window.DeviceOrientationEvent!=="undefined";
  var coarse = window.matchMedia("(pointer: coarse)").matches;

  function fade(delay){ setTimeout(function(){ btn.style.opacity="0"; }, delay||2600); }

  if(needsTap){
    btn.textContent="TAP TO TILT WITH YOUR PHONE";
    btn.classList.add("live");
    btn.addEventListener("click", function(){
      DeviceOrientationEvent.requestPermission().then(function(ok){
        if(ok==="granted"){
          window.addEventListener("deviceorientation", orient);
          btn.textContent="NOW TILT YOUR PHONE";
          fade(3200);
        }else{
          btn.classList.remove("live"); btn.textContent="DRAG IT INSTEAD"; fade();
        }
      }).catch(function(){
        btn.classList.remove("live"); btn.textContent="DRAG IT INSTEAD"; fade();
      });
    });
  }else if(hasGyro && coarse){
    window.addEventListener("deviceorientation", orient);
    btn.textContent="TILT YOUR PHONE";
    fade(4000);
  }else{
    btn.textContent="DRAG TO SWING IT";
    stage.addEventListener("pointerdown", function(){ fade(400); }, {once:true});
  }
}

/* 2. THE ENGINE
   A reviewer wearing an M who says the bust was right tells us the M
   holds a 38in bust. One who says tight tells us it holds less than
   their 39in. Every review is one observation of what a size holds:
       capacity = their measurement + rating x step */
var DIM={
  bust:{k:"bust",label:"Bust",w:1,step:1.5,grade:2,minGrade:.8,unit:"in"},
  waist:{k:"waist",label:"Waist",w:.6,step:1.5,grade:2,minGrade:.8,unit:"in"},
  hip:{k:"hip",label:"Hip",w:.35,step:1.5,grade:2,minGrade:.8,unit:"in"},
  foot:{k:"foot",label:"Length",w:1,step:.28,grade:.167,minGrade:.06,unit:"in"},
  width:{k:"width",label:"Width",w:.55,step:.7,grade:.04,minGrade:0,unit:"width"}
};
var CUPS=["A","B","C","D","DD","DDD","G","H"];
/* The stored cup stays the US letter, because that is what the size
   charts are graded on. The label is bilingual: a UK shopper looking
   for an E should not have to know it is a US DD. Display only, so no
   saved profile has to be migrated. */
var CUP_LABEL={"DD":"DD/E","DDD":"DDD/F"};
function cupLabel(c){ return CUP_LABEL[c] || c; }
var WIDTHW={"-1":"narrow","0":"standard","1":"wide","2":"extra wide"};
var SHRINK=1.6;

/* UNITS. The engine works in inches throughout — that is only the
   storage unit. What the shopper types and reads is decided by the
   country they picked, because asking a Berliner for her bust in
   inches is the same failure as answering her in UK sizes. */
var UNITS="imp";
var SYS_UNITS={us:"imp",uk:"imp",eu:"met",fr:"met",it:"met",au:"met",jp:"met",alpha:"met"};
var LB_KG=2.20462;
function met(){ return UNITS==="met"; }
function cmIn(v){ return v/2.54; }
function inCm(v){ return v*2.54; }
function r1(v){ return Math.round(v*10)/10; }

function shoeToFoot(sys,size){
  var n=parseFloat(size); if(isNaN(n)) return null;
  var usm = sys==="usm"?n : sys==="usw"?n-1.5 : sys==="uk"?n+1 : n-33;
  return 10.625+(usm-9)/3;
}
function cupDepth(c){var i=CUPS.indexOf(c); return i<0?null:i+1;}
function allowance(d,s){
  if(d.k!=="bust") return 0;
  var x=cupDepth(s&&s.cup); return x==null?0:Math.max(0,x-2)*.4;
}
function capacities(p,list){
  var out={};
  p.dims.forEach(function(d){
    var obs={}, mean={};
    list.forEach(function(r){
      var body=r[d.k], rating=r.a&&r.a[d.k];
      if(body==null||rating==null) return;
      (obs[r.worn]=obs[r.worn]||[]).push(body+rating*d.step+allowance(d,r));
    });
    Object.keys(obs).forEach(function(s){
      mean[s]=obs[s].reduce(function(m,n){return m+n;},0)/obs[s].length;
    });

    var chart=p.chart&&p.chart[d.k];

    /* DRIFT — how far reality sits from what the brand published,
       averaged across every size that has reviews. One number, and it
       carries to sizes nobody has reviewed yet. */
    var ds=0,dn=0;
    p.sizes.forEach(function(s){
      if(!obs[s]||!chart||chart[s]==null) return;
      ds+=(mean[s]-chart[s])*obs[s].length; dn+=obs[s].length;
    });
    var drift=dn?ds/dn:0;

    var pts=Object.keys(obs).map(function(s){
      return {x:p.sizes.indexOf(s),y:mean[s],n:obs[s].length};
    }).filter(function(q){return q.x>=0;});
    var slope=d.grade, inter=null;
    if(pts.length>=2){
      var N=pts.reduce(function(a,q){return a+q.n;},0);
      var mx=pts.reduce(function(a,q){return a+q.x*q.n;},0)/N;
      var my=pts.reduce(function(a,q){return a+q.y*q.n;},0)/N;
      var num=0,den=0;
      pts.forEach(function(q){num+=q.n*(q.x-mx)*(q.y-my);den+=q.n*(q.x-mx)*(q.x-mx);});
      slope=den>0?num/den:d.grade;
      if(slope<d.minGrade) slope=d.grade;
      inter=my-slope*mx;
    }else if(pts.length===1){ inter=pts[0].y-slope*pts[0].x; }

    out[d.k]={grade:slope,drift:drift,driftN:dn,hasChart:!!chart};

    p.sizes.forEach(function(s,i){
      var prior=(chart&&chart[s]!=null)?chart[s]+drift:(inter==null?null:slope*i+inter);
      var n=obs[s]?obs[s].length:0;
      /* HANDOVER: no reviews on this size and you get the prior, pure.
         Each review pulls it toward what people actually reported. */
      var val=n?(prior==null?mean[s]:(n*mean[s]+SHRINK*prior)/(n+SHRINK)):prior;
      out[d.k][s]={val:val,n:n,chart:(chart&&chart[s]!=null)?chart[s]:null,
                   share:prior==null?1:n/(n+SHRINK)};
    });
  });
  return out;
}

function scoreWith(p,cap,me,pick){
  return p.sizes.map(function(size){
    var score=0,used=0,detail={};
    p.dims.forEach(function(d){
      var c=cap[d.k][size]; if(!c) return;
      var v=pick(c), body=me[d.k];
      if(v==null||body==null) return;
      var need=body+allowance(d,me), slack=v-need;
      score+=Math.abs(slack)*d.w*(slack<0?1.9:1)*(d.unit==="in"?1:1.6);
      detail[d.k]={slack:slack,cap:v,n:c.n,chart:c.chart,share:c.share};
      used++;
    });
    var ev=p.dims.reduce(function(n,d){return n+((cap[d.k][size]&&cap[d.k][size].n)||0);},0);
    return {size:size,score:score,detail:detail,usable:used>0,evidence:ev};
  }).filter(function(x){return x.usable;}).sort(function(a,b){return a.score-b.score;});
}

function recommend(p,list,me){
  var cap=capacities(p,list);
  var ranked=scoreWith(p,cap,me,function(c){return c.val;});
  if(!ranked.length) return null;

  var chartRanked=scoreWith(p,cap,me,function(c){return c.chart;});
  var chartSize=chartRanked.length?chartRanked[0].size:null;

  var best=ranked[0],next=ranked[1];
  var close=!!(next&&next.score-best.score<p.dims[0].grade*.55);
  var conf=Math.min(1,best.evidence*.26+Math.min(list.length,14)/14*.68);

  /* Only dimensions that actually scored get a vote on provenance. A
     dimension with no chart and no reviews has nothing to say, and
     counting it was reporting real-fit evidence that does not exist. */
  var sh=0,shn=0;
  p.dims.forEach(function(d){
    var c=cap[d.k][best.size];
    if(c && c.val!=null){ sh+=c.share*d.w; shn+=d.w; }
  });

  var prim=p.dims[0];
  return {best:best,next:next,close:close,conf:conf,cap:cap,n:list.length,
          chartSize:chartSize,share:shn?sh/shn:0,
          drift:cap[prim.k].drift,driftN:cap[prim.k].driftN};
}

/* 3. DATA — the two demo products carry made-up reviews, and the page
   says so. Every real brand starts empty. */
var SEED={
  tee:[
    {u:"jordan.k",bust:40,waist:34,hip:39,worn:"L",a:{bust:0,waist:0,hip:0},note:"Fits true to size. Slightly oversized but comfortable, and the cotton has real weight.",h:72,wt:180},
    {u:"maria.s",bust:34,waist:27,hip:36,worn:"S",a:{bust:0,waist:1,hip:1},cup:"B",note:"Love the fit. Relaxed but not baggy, hits right at the hip.",h:64,wt:120},
    {u:"devon.r",bust:38,waist:32,hip:38,worn:"M",a:{bust:0,waist:0,hip:0},note:"Exactly what the chart said. Sleeves a touch long but that is the cut.",h:68,wt:150},
    {u:"aleks.p",bust:39,waist:33,hip:39,worn:"M",a:{bust:0,waist:0,hip:0},note:"Sized up and glad I did. The S pulled across the chest.",h:67,wt:155},
    {u:"marcus.t",bust:44,waist:38,hip:42,worn:"XL",a:{bust:0,waist:0,hip:0},note:"True to size on a bigger frame. Shoulder seam sits where it should.",h:71,wt:200},
    {u:"nina.c",bust:36,waist:29,hip:38,worn:"M",a:{bust:1,waist:1,hip:1},cup:"C",note:"Roomier than expected. Kept it because I wanted oversized.",h:63,wt:135},
    {u:"big.dre",bust:50,waist:46,hip:48,worn:"XXL",a:{bust:0,waist:0,hip:0},note:"Finally an oversized tee actually cut for oversized people.",h:74,wt:250},
    {u:"cass.d",bust:37,waist:31,hip:38,worn:"S",a:{bust:-1,waist:-1,hip:0},cup:"D",note:"Runs small through the body. Should have taken the M.",h:66,wt:145},
    {u:"omar.b",bust:45,waist:40,hip:43,worn:"L",a:{bust:-1,waist:-1,hip:0},note:"Tight everywhere. XL next time.",h:73,wt:210},
    {u:"tomas.l",bust:41,waist:35,hip:40,worn:"XL",a:{bust:-1,waist:0,hip:0},note:"L was tight in the shoulders, XL solved it.",h:69,wt:175}
  ],
  sneaker:[
    {u:"jordan.k",foot:10.6,width:0,worn:"9.5",a:{foot:0,width:0},note:"True to size, no break-in needed.",h:72,wt:180},
    {u:"kelsey.m",foot:10.25,width:0,worn:"9",a:{foot:-1,width:0},note:"Short in the toe. Go half a size up.",h:66,wt:140},
    {u:"tomas.l",foot:10.95,width:1,worn:"10.5",a:{foot:0,width:-1},note:"Length right but narrow across the ball of the foot.",h:69,wt:175},
    {u:"nina.c",foot:9.95,width:-1,worn:"9",a:{foot:0,width:1},note:"Roomy for a narrow foot, needed a thicker sock.",h:63,wt:135},
    {u:"big.dre",foot:11.3,width:0,worn:"11",a:{foot:-1,width:0},note:"Cramped my toes. 11.5 would have been right.",h:74,wt:250},
    {u:"ray.o",foot:10.6,width:1,worn:"10",a:{foot:1,width:0},note:"Bit of slide in the heel, otherwise fine.",h:70,wt:185},
    {u:"priya.n",foot:10.1,width:0,worn:"8.5",a:{foot:-1,width:0},note:"Definitely runs short. Sized up and it was perfect.",h:65,wt:140},
    {u:"marcus.t",foot:11,width:0,worn:"10.5",a:{foot:0,width:0},note:"Spot on out of the box.",h:71,wt:200},
    {u:"devon.r",foot:10.4,width:2,worn:"10",a:{foot:0,width:-1},note:"Wide feet beware. Length was good.",h:68,wt:150},
    {u:"cass.d",foot:9.8,width:1,worn:"8.5",a:{foot:0,width:-1},note:"Snug across the width but the length is right.",h:66,wt:145}
  ]
};
var SHOE_LADDER=["7","7.5","8","8.5","9","9.5","10","10.5","11","11.5","12","12.5","13"];

/* Every verified brand becomes a product whose chart is its own
   published body chart. */
function brandProducts(){
  return BRANDS.map(function(b){
    var nm=b[0], rows=b[3], chart={}, keys=[];
    [["bust",2],["waist",3],["hip",4]].forEach(function(p){
      if(rows.some(function(r){return r[p[1]]!=null;})){
        chart[p[0]]={};
        rows.forEach(function(r){ if(r[p[1]]!=null) chart[p[0]][r[0]]=r[p[1]]; });
        keys.push(p[0]);
      }
    });
    var first=keys[0], vals=rows.map(function(r){return chart[first][r[0]];})
                               .filter(function(v){return v!=null;});
    var grade = vals.length>1 ? (vals[vals.length-1]-vals[0])/(vals.length-1) : 2;
    if(!(grade>0.3)) grade=2;
    return {
      id:"b"+nm.toLowerCase().replace(/[^a-z0-9]+/g,""),
      name:nm, brand:nm, region:b[1], src:b[2], real:true, grade:grade,
      sizes:rows.map(function(r){return r[0];}),
      us:rows.reduce(function(o,r){ o[r[0]]=r[1]; return o; },{}),
      dims:keys.map(function(k){
        var o={}; for(var q in DIM[k]) o[q]=DIM[k][q];
        o.grade=grade; o.step=grade*0.75; o.minGrade=grade*0.4; return o;
      }),
      chart:chart
    };
  });
}
/* FOOTWEAR. Same engine, different chart. A shoe brand publishes a
   foot length for every size, so length is the dimension that decides
   it — and the brand's own US/UK/EU columns are the conversion, because
   there is no universal shoe ladder that survives contact with reality. */
function shoeProducts(){
  if(typeof SHOES==="undefined") return [];
  return SHOES.map(function(b){
    var nm=b[0], rows=b[3], chart={foot:{}};
    rows.forEach(function(r){ chart.foot[r[0]]=r[4]/2.54; });
    var vals=rows.map(function(r){ return r[4]/2.54; });
    var grade = vals.length>1 ? (vals[vals.length-1]-vals[0])/(vals.length-1) : .167;
    if(!(grade>0.04)) grade=.167;
    var dl={}; for(var q in DIM.foot) dl[q]=DIM.foot[q];
    dl.grade=grade; dl.step=grade*1.7; dl.minGrade=grade*0.4;
    var dw={}; for(var q2 in DIM.width) dw[q2]=DIM.width[q2];
    return {
      id:"s"+nm.toLowerCase().replace(/[^a-z0-9]+/g,""),
      name:nm, brand:nm, region:b[1], src:b[2], real:true, shoe:true, grade:grade,
      sizes:rows.map(function(r){ return r[0]; }),
      alt:rows.reduce(function(o,r){ o[r[0]]={us:r[1],uk:r[2],eu:r[3]}; return o; },{}),
      dims:[dl,dw],
      chart:chart
    };
  });
}
var DEMOS=[
  {id:"tee",name:"Oversized tee",brand:"a heavyweight cotton tee",
   sizes:["XS","S","M","L","XL","XXL"],dims:[DIM.bust,DIM.waist,DIM.hip],
   chart:{
     bust:{XS:34,S:37,M:40,L:43,XL:47,XXL:51},
     waist:{XS:28,S:31,M:34,L:37,XL:41,XXL:45},
     hip:{XS:34,S:37,M:40,L:43,XL:47,XXL:51}
   }},
  {id:"sneaker",name:"Running sneaker",brand:"a classic runner",
   sizes:SHOE_LADDER,dims:[DIM.foot,DIM.width],
   chart:{
     foot:(function(){var o={};SHOE_LADDER.forEach(function(s){o[s]=10.625+(parseFloat(s)-9)/3;});return o;})(),
     width:(function(){var o={};SHOE_LADDER.forEach(function(s){o[s]=0;});return o;})()
   }}
];
DEMOS.forEach(function(p){ p.demo=true; });
var CLOTHES  = brandProducts();
var FOOTWEAR = shoeProducts();
var SHOE0    = CLOTHES.length;
var PRODUCTS = CLOTHES.concat(FOOTWEAR).concat(DEMOS);
var CAT="clothing";
var active=0, me=null, pending=null;
var K_PROF="trytaty:profile:v1", K_REV="trytaty:reviews:v1";
var reviews=JSON.parse(JSON.stringify(SEED));
PRODUCTS.forEach(function(p){ if(!reviews[p.id]) reviews[p.id]=[]; });

function load(){
  try{ var p=localStorage.getItem(K_PROF); if(p) me=JSON.parse(p); }catch(e){}
  try{
    var r=localStorage.getItem(K_REV);
    if(r){ var extra=JSON.parse(r);
      Object.keys(extra).forEach(function(k){ if(reviews[k]) reviews[k]=reviews[k].concat(extra[k]); });
    }
  }catch(e){}
}
function saveProfile(){ try{ localStorage.setItem(K_PROF,JSON.stringify(me)); }catch(e){} }
function saveReviews(){
  var mine={};
  Object.keys(reviews).forEach(function(k){
    mine[k]=reviews[k].filter(function(r){return r.mine;});
  });
  try{ localStorage.setItem(K_REV,JSON.stringify(mine)); }catch(e){}
}

/* 4. UI */
var esc=function(s){return String(s==null?"":s).replace(/[&<>"]/g,function(c){
  return {"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;"}[c];});};
function ftinImp(i){ return Math.floor(i/12)+"'"+Math.round(i%12)+'"'; }
var ftin=function(i){ return met() ? Math.round(inCm(i))+" cm" : ftinImp(i); };
var showIn=function(v){ return met() ? r1(inCm(v))+" cm" : r1(v)+'"'; };
function showDim(d,v){ return d.unit==="in"?showIn(v):(Math.round(v*10)/10)+" widths"; }
var tt;
function toast(m){var e=$("toast");e.textContent=m;e.classList.add("on");clearTimeout(tt);tt=setTimeout(function(){e.classList.remove("on");},2500);}
function parseHeight(s){
  var m=String(s||"").trim().match(/(\d+(?:\.\d+)?)\s*['’]?\s*(\d+(?:\.\d+)?)?/);
  if(!m) return null;
  var a=+m[1], b=m[2]?+m[2]:0;
  if(a>90) return a/2.54; if(a>36) return a; return a*12+b;
}
function parseHeightU(s){
  if(met()){
    var n=parseFloat(String(s||"").replace(/[^0-9.]/g,""));
    return isNaN(n)?null:cmIn(n);
  }
  return parseHeight(s);
}
function hashColor(s){
  var n=0, c=["#1D4A42","#6B8077","#B98070","#2D4A63","#8C7A63"];
  for(var i=0;i<s.length;i++) n=(n*31+s.charCodeAt(i))>>>0;
  return c[n%c.length];
}
function convRowForUS(us){
  var n=String(us==null?"":us).match(/\d+/g); if(!n) return null;
  var t=parseInt(n[n.length-1],10), best=null, gap=1e9;
  CONV.forEach(function(r){ var g=Math.abs(parseInt(r[0],10)-t); if(g<gap){gap=g;best=r;} });
  return best;
}
/* A shopper's baseline size is not one brand's opinion — it is the
   median of what every brand that publishes a US equivalent says. */
function baselineUS(){
  var picks=[];
  PRODUCTS.forEach(function(p){
    if(!p.real||!p.us) return;
    var out=recommend(p,[],me); if(!out) return;
    var n=String(p.us[out.best.size]||"").match(/\d+/g);
    if(n) picks.push(parseInt(n[n.length-1],10));
  });
  if(!picks.length) return null;
  picks.sort(function(a,b){return a-b;});
  return picks[Math.floor(picks.length/2)];
}
function sysLabel(k){
  return {us:"US",uk:"UK",eu:"EU",fr:"French",it:"Italian",au:"Australian",jp:"Japanese",alpha:"alpha"}[k]||"US";
}

(function fillSelects(){
  var b=$("p-band"), c=$("p-cup"), s=$("p-ssize"), h="";
  b.innerHTML='<option value="">—</option>';
  for(var i=28;i<=48;i+=2) b.innerHTML+='<option>'+i+'</option>';
  c.innerHTML='<option value="">—</option>'+CUPS.map(function(x){
    return '<option value="'+x+'">'+cupLabel(x)+'</option>'; }).join("");
  for(var n=4;n<=16;n+=0.5) h+='<option'+(n===9?' selected':'')+'>'+n+'</option>';
  s.innerHTML=h;
})();

/* Country first, units follow. Anything already typed is converted
   rather than thrown away. */
function paintUnitLabels(){
  var m=met();
  function txt(id,t){ var e=$(id); if(e) e.textContent=t; }
  function ph(id,t){ var e=$(id); if(e) e.placeholder=t; }
  txt("u-h", m ? "cm" : "just type the numbers");
  txt("u-w", m ? "kg — optional" : "lb — optional");
  txt("u-body", m ? "Tape snug, not pulled tight, over light clothing. In centimetres."
                  : "Tape snug, not pulled tight, over light clothing. In inches.");
  txt("u-foot", m ? "cm — optional, better" : "in — optional, better");
  ph("p-h", m ? "168" : "5'8\"");
  ph("p-w", m ? "66" : "150");
  ph("p-bust", m ? "91" : "38");
  ph("p-waist", m ? "81" : "32");
  ph("p-hip", m ? "97" : "38");
  ph("p-foot", m ? "27" : "10.6");
  window.TATY_METRIC = m;
}

function applyUnits(){
  var sel=$("p-sys"); if(!sel) return;
  var next = SYS_UNITS[sel.value] || "imp";
  if(next !== UNITS){
    var was = UNITS;
    var hEl = $("p-h"), hin = hEl && hEl.value ? parseHeightU(hEl.value) : null;
    UNITS = next;
    ["p-bust","p-waist","p-hip","p-foot"].forEach(function(id){
      var e=$(id), v=parseFloat(e.value);
      if(isNaN(v)) return;
      e.value = r1(was==="imp" ? inCm(v) : cmIn(v));
    });
    var w=$("p-w"), wv=parseFloat(w.value);
    if(!isNaN(wv)) w.value = Math.round(was==="imp" ? wv/LB_KG : wv*LB_KG);
    if(hEl && hin!=null) hEl.value = next==="met" ? Math.round(inCm(hin)) : ftinImp(hin);
  }
  paintUnitLabels();
  if(me) render();
}

function show(which){
  ["setup","confirm","result"].forEach(function(id){
    $(id).classList.toggle("hide", id!==which);
  });
}

$("toReview").onclick=function(){
  var h=parseHeightU($("p-h").value), wt=parseFloat($("p-w").value);
  var bust=parseFloat($("p-bust").value), waist=parseFloat($("p-waist").value), hip=parseFloat($("p-hip").value);
  var foot=parseFloat($("p-foot").value);
  if(met()){
    if(!isNaN(wt)) wt=wt*LB_KG;
    bust=cmIn(bust); waist=cmIn(waist); hip=cmIn(hip);
    if(!isNaN(foot)) foot=cmIn(foot);
  }
  /* Weight is optional: it does not move the recommendation, it only
     gives other shoppers context on a review. Blocking on it costs
     people at the one field they are touchiest about. */
  if(h==null||isNaN(bust)||isNaN(waist)||isNaN(hip)){
    toast("Height and the three body measurements are needed."); return;
  }
  var sys=$("p-ssys").value, ssize=$("p-ssize").value;
  pending={h:h,wt:(isNaN(wt)?null:wt),bust:bust,waist:waist,hip:hip,
    sys:$("p-sys").value,
    band:$("p-band").value||null,cup:$("p-cup").value||null,
    shoeSystem:sys,shoeSize:ssize,width:+$("p-width").value,
    foot:!isNaN(foot)?foot:shoeToFoot(sys,ssize),footMeasured:!isNaN(foot),savedAt:Date.now()};
  renderConfirm();
};

function renderConfirm(){
  var p=pending, sys={usm:"US men",usw:"US women",uk:"UK",eu:"EU"}[p.shoeSystem];
  var rows=[["Height",ftin(p.h)],
    ["Weight", p.wt==null ? "—" : (met() ? Math.round(p.wt/LB_KG)+" kg" : Math.round(p.wt)+" lb")],
    ["Bust / chest",showIn(p.bust)],["Waist",showIn(p.waist)],["Hip",showIn(p.hip)]];
  if(p.band&&p.cup) rows.push(["Bra",p.band+cupLabel(p.cup)]);
  rows.push(["Your sizing", sysLabel(p.sys)]);
  rows.push(["Shoe size",sys+" "+p.shoeSize]);
  rows.push(["Width",WIDTHW[p.width]]);
  rows.push([p.footMeasured?"Foot length, measured":"Foot length, from your size", p.foot?showIn(p.foot):"—"]);
  $("recap").innerHTML=rows.map(function(r,i){
    return '<div class="rr'+(i%2?' odd':'')+'"><span>'+esc(r[0])+'</span><b>'+esc(r[1])+'</b></div>';
  }).join("");
  $("sure").checked=false; $("save").disabled=true;
  show("confirm");
  $("finder").scrollIntoView({behavior:"smooth",block:"start"});
}
$("sure").onchange=function(e){ $("save").disabled=!e.target.checked; };
$("back").onclick=function(){ show("setup"); };
$("save").onclick=function(){
  var wasEdit=!!me;
  /* renderRevForm too: on a first save the review form is still showing
     its "save your measurements above" placeholder, and without this it
     stays that way until the page is reloaded. */
  me=pending; saveProfile(); render(); renderReviews(); renderRevForm(); show("result");
  toast(wasEdit?"Updated. Everything recalculated.":"Saved. You won't be asked again.");
};
$("cancel").onclick=function(){ show("result"); };
if($("p-sys")) $("p-sys").addEventListener("change", applyUnits);

function openSetup(edit){
  var isEdit=!!edit&&!!me;
  $("s-kicker").textContent=isEdit?"YOUR MEASUREMENTS":"ONE TIME ONLY";
  $("s-title").innerHTML=isEdit?"Change anything.":"Measure once.<br>Never again.";
  $("toReview").textContent=isEdit?"Review my changes":"Review my measurements";
  $("cancel").classList.toggle("hide",!isEdit);
  if(me){
    if(me.sys) $("p-sys").value=me.sys;
    $("p-h").value = met() ? Math.round(inCm(me.h)) : ftinImp(me.h);
    $("p-w").value = me.wt==null ? "" : (met() ? Math.round(me.wt/LB_KG) : Math.round(me.wt));
    $("p-bust").value  = met() ? r1(inCm(me.bust))  : me.bust;
    $("p-waist").value = met() ? r1(inCm(me.waist)) : me.waist;
    $("p-hip").value   = met() ? r1(inCm(me.hip))   : me.hip;
    if(me.band)$("p-band").value=me.band; if(me.cup)$("p-cup").value=me.cup;
    $("p-ssys").value=me.shoeSystem; $("p-ssize").value=me.shoeSize;
    $("p-width").value=me.width;
    $("p-foot").value = me.footMeasured ? (met() ? r1(inCm(me.foot)) : me.foot) : "";
  }
  show("setup");
}

/* Seven brands on screen; the rest come in through search and take the
   front slot, so the row never grows past a thumb's reach. */
var SHOE_TOP=["Nike","adidas","New Balance","Converse","HOKA","UGG","Dr. Martens"];
var VIS={
  clothing:[0,1,2,3,4,5,6],
  footwear:SHOE_TOP.map(function(n){
    for(var i=0;i<FOOTWEAR.length;i++) if(FOOTWEAR[i].name===n) return SHOE0+i;
    return -1;
  }).filter(function(i){ return i>=0; })
};
if(!VIS.footwear.length) VIS.footwear=FOOTWEAR.slice(0,7).map(function(p,i){ return SHOE0+i; });
function catOf(p){ return (p.shoe||p.id==="sneaker") ? "footwear" : "clothing"; }
function paintCat(){
  var box=$("cattoggle");
  if(box) Array.prototype.forEach.call(box.querySelectorAll("button"),function(b){
    b.setAttribute("aria-pressed", b.dataset.cat===CAT);
  });
  var s=$("bsearch");
  if(s) s.placeholder = CAT==="footwear"
    ? "Search all "+FOOTWEAR.length+" shoe brands…"
    : "Search all "+CLOTHES.length+" clothing brands…";
}
function pickBrand(i){
  var c=catOf(PRODUCTS[i]);
  CAT=c;
  if(!PRODUCTS[i].demo && VIS[c].indexOf(i)<0){ VIS[c].unshift(i); VIS[c]=VIS[c].slice(0,7); }
  active=i; paintCat(); render(); renderReviews(); renderRevForm();
}
(function catToggle(){
  var box=$("cattoggle"); if(!box) return;
  Array.prototype.forEach.call(box.querySelectorAll("button"),function(b){
    b.onclick=function(){
      var c=b.dataset.cat;
      if(c===CAT || !VIS[c] || !VIS[c].length) return;
      CAT=c; active=VIS[c][0];
      paintCat(); render(); renderReviews(); renderRevForm();
    };
  });
})();
function renderSwitch(){
  var demo=PRODUCTS.filter(function(p){return p.demo && catOf(p)===CAT;});
  var html=VIS[CAT].map(function(i){
    return '<button data-i="'+i+'" aria-pressed="'+(i===active)+'">'+esc(PRODUCTS[i].name)+'</button>';
  }).join("");
  html+=demo.map(function(p){
    var i=PRODUCTS.indexOf(p);
    return '<button class="demochip" data-i="'+i+'" aria-pressed="'+(i===active)+'">'+esc(p.name)+' · demo</button>';
  }).join("");
  $("switch").innerHTML=html;
  Array.prototype.forEach.call($("switch").querySelectorAll("button"),function(b){
    b.onclick=function(){ pickBrand(+b.dataset.i); };
  });
}
(function brandSearch(){
  var box=$("bsearch"), out=$("bresults");
  if(!box) return;
  function close(){ out.classList.add("hide"); }
  box.addEventListener("input",function(){
    var q=box.value.trim().toLowerCase();
    if(!q){ close(); return; }
    var hits=[];
    PRODUCTS.forEach(function(p,i){
      if(p.real && catOf(p)===CAT && p.name.toLowerCase().indexOf(q)>=0) hits.push([p,i]);
    });
    out.innerHTML = hits.length
      ? hits.slice(0,40).map(function(h){
          return '<button data-i="'+h[1]+'">'+esc(h[0].name)+'<i>'+esc(h[0].region)+'</i></button>';
        }).join("")
      : '<p class="none">No verified chart for that yet. Only brands whose own published chart we could read are listed.</p>';
    out.classList.remove("hide");
    Array.prototype.forEach.call(out.querySelectorAll("button"),function(b){
      b.onclick=function(){ pickBrand(+b.dataset.i); box.value=""; close();
        $("finder").scrollIntoView({behavior:"smooth",block:"start"}); };
    });
  });
  box.addEventListener("blur",function(){ setTimeout(close,160); });
})();

function render(){
  if(!me) return;
  var prod=PRODUCTS[active], list=reviews[prod.id];

  $("prof").innerHTML=
    [["Ht",ftin(me.h)],["Bust",showIn(me.bust)],["Waist",showIn(me.waist)],["Hip",showIn(me.hip)],
     ["Foot",showIn(me.foot)]]
    .map(function(x){return '<span class="chip">'+x[0]+' <b>'+x[1]+'</b></span>';}).join("")
    +'<button class="edit" id="editme">Edit</button>';
  $("editme").onclick=function(){ openSetup(true); };

  renderSwitch();

  var out=recommend(prod,list,me);
  if(!out){ $("verdict").innerHTML='<p class="vwhy">Not enough data on this one yet.</p>'; return; }
  var b=out.best, det=b.detail;
  var isShoe=(prod.shoe||prod.id==="sneaker");

  var tight=prod.dims.filter(function(d){return det[d.k]&&det[d.k].slack<(d.unit==="in"?-.3:-.25);});
  var loose=prod.dims.filter(function(d){
    return det[d.k]&&det[d.k].slack>(d.unit==="in"?(isShoe?.5:2.5):.6);});
  var why = tight.length
      ? "Snug at the "+tight.map(function(d){return d.label.toLowerCase();}).join(" and ")+" — people your size said the same."
    : loose.length
      ? "Generous at the "+loose.map(function(d){return d.label.toLowerCase();}).join(" and ")+", which is the cut, not an error."
      : "Sits where " + esc(prod.demo ? "this piece" : prod.brand + "’s chart") + " intends across every measurement that matters.";

  var prim=prod.dims[0];
  var driftTxt;
  if(!out.driftN){
    driftTxt="Straight off the brand chart — no reviews yet";
  }else if(out.chartSize&&out.chartSize!==b.size){
    driftTxt=(out.drift<0?"Runs small":"Runs large")+
      " — the chart would have said "+esc(out.chartSize);
  }else if(Math.abs(out.drift)<0.25){
    driftTxt="Runs true to the brand chart";
  }else{
    driftTxt=showDim(prim,Math.abs(out.drift))+(out.drift<0?" small":" large")+" of the chart";
  }

  $("verdict").innerHTML=
    '<div class="vline"><span class="vsize">'+esc(b.size)+'</span>'+
    '<span class="vcap">'+(out.close?"or "+esc(out.next.size)+" — it's close":"is your size in "+esc(prod.brand))+'</span></div>'+
    xlate(prod,b.size)+
    '<span class="pill">'+driftTxt+'</span>'+
    '<div class="handover"><span class="hb"><i style="width:'+Math.round(out.share*100)+'%"></i></span>'+
    '<span class="hl">'+Math.round(out.share*100)+'% REAL FITS · '+
      (100-Math.round(out.share*100))+'% BRAND CHART</span></div>'+
    '<p class="vwhy">'+why+'</p>'+
    '<div class="conf"><span>CONFIDENCE</span><span class="t"><i style="width:'+
      Math.round(out.conf*100)+'%"></i></span><span>'+
      (out.driftN?(out.conf<.34?"THIN":out.conf<.7?"FAIR":"SOLID"):"CHART ONLY")+'</span></div>';

  renderChartTable(prod,out,b);
  renderConv();

  $("fitbars").innerHTML=prod.dims.map(function(d){
    var x=det[d.k]; if(!x) return "";
    var span=d.unit==="in"?(isShoe?1:6):1.5;
    var pct=Math.max(-1,Math.min(1,x.slack/span)), half=Math.abs(pct)*50;
    var left=pct<0?50-half:50;
    var tAt=d.unit==="in"?-.3:-.25, lAt=d.unit==="in"?(isShoe?.5:2.5):.6;
    var col=x.slack<tAt?"#BE4238":x.slack>lAt?"#3D6DA8":"#4C7A5A";
    var word=x.slack<tAt?"snug":x.slack>lAt?"roomy":"as cut";
    return '<div class="fit"><span>'+d.label+'</span><span class="track">'+
      '<i style="left:'+left+'%;width:'+Math.max(half,2)+'%;background:'+col+'"></i>'+
      '<span class="mid"></span></span><em>'+showDim(d,Math.abs(x.slack))+' '+word+'</em></div>';
  }).join("");
}

/* The brand's label is in the brand's system. This is the same size in
   the one the shopper actually recognises. */
var SHOE_SYS={us:"us",uk:"uk",au:"uk",eu:"eu",fr:"eu",it:"eu",jp:"jp",alpha:"eu"};
function xlate(prod,size){
  if(!me||!me.sys) return "";
  if(prod.shoe){
    var k=SHOE_SYS[me.sys]||"us";
    if(k==="jp"){
      var f=prod.chart.foot[size];
      return f==null ? "" :
        '<span class="xlate">= <b>'+r1(inCm(f))+' cm</b> in your sizing</span>';
    }
    var a=(prod.alt&&prod.alt[size])||{}, v=a[k];
    var lbl={us:"US",uk:"UK",eu:"EU"}[k];
    /* Some brands publish only two of the three columns. Say so and
       give what they do publish, rather than inventing the third. */
    if(!v){
      if(k==="eu"||!a.eu) return "";
      return '<span class="xlate">= <b>EU '+esc(a.eu)+'</b> — '+esc(prod.name)+
             ' publishes no '+lbl+' column for these</span>';
    }
    if(String(size).toUpperCase()===(lbl+" "+v).toUpperCase()) return "";
    return '<span class="xlate">= <b>'+lbl+" "+esc(v)+'</b> in your sizing</span>';
  }
  var row = (prod.us&&prod.us[size]) ? convRowForUS(prod.us[size]) : convRowForUS(baselineUS());
  if(!row) return "";
  var v=row[CONV_KEYS.indexOf(me.sys)];
  if(!v) return "";
  var shown = String(size).replace(/[^0-9a-z]/gi,"").toLowerCase();
  if(shown===String(v).toLowerCase()) return "";
  return '<span class="xlate">= <b>'+sysLabel(me.sys)+" "+esc(v)+'</b> in your sizing</span>';
}

function renderShoeConv(prod){
  var out=recommend(prod,reviews[prod.id],me);
  var pick=out?out.best.size:null;
  var head='<tr><th>'+esc(prod.name)+'</th><th>US</th><th>UK</th><th>EU</th><th>Foot</th></tr>';
  var body=prod.sizes.map(function(s){
    var a=(prod.alt&&prod.alt[s])||{}, f=prod.chart.foot[s];
    return '<tr class="'+(s===pick?"yours":"")+'"><td>'+esc(s)+'</td>'+
      '<td>'+esc(a.us||"—")+'</td><td>'+esc(a.uk||"—")+'</td>'+
      '<td>'+esc(a.eu||"—")+'</td>'+
      '<td>'+(f!=null?showIn(f):"—")+'</td></tr>';
  }).join("");
  $("convbox").innerHTML=
    '<h3 style="font-size:19px;font-weight:500;margin-bottom:4px">Country to country</h3>'+
    '<p class="sub" style="font-size:13.5px;margin-bottom:12px">'+esc(prod.name)+
      '’s own published ladder. Shoe sizes do not survive one universal table — every brand runs its own, so this is theirs.</p>'+
    '<div class="scroll"><table class="convtab">'+head+body+'</table></div>'+
    '<p class="convnote">'+(pick
      ? "Your row is highlighted. Foot length is the column that actually decides it — the rest are each country’s name for the same shoe."
      : "Add your measurements above and your row lights up.")+'</p>';
}

function renderConv(){
  var prod=PRODUCTS[active];
  if(prod.shoe){ renderShoeConv(prod); return; }
  var base=baselineUS(), row=convRowForUS(base), mine=CONV_KEYS.indexOf(me.sys);
  var head='<tr>'+CONV_KEYS.map(function(k,i){
    return '<th class="'+(i===mine?"col":"")+'">'+(k==="alpha"?"Alpha":k.toUpperCase())+'</th>';
  }).join("")+'</tr>';
  var body=CONV.map(function(r){
    var isMe = row && r[0]===row[0];
    return '<tr class="'+(isMe?"yours":"")+'">'+r.map(function(v,i){
      return '<td class="'+(i===mine?"col":"")+'">'+esc(v||"—")+'</td>';
    }).join("")+'</tr>';
  }).join("");
  $("convbox").innerHTML=
    '<h3 style="font-size:19px;font-weight:500;margin-bottom:4px">Country to country</h3>'+
    '<p class="sub" style="font-size:13.5px;margin-bottom:12px">Your row is highlighted, your system is the shaded column.</p>'+
    '<div class="scroll"><table class="convtab">'+head+body+'</table></div>'+
    '<p class="convnote">'+(base==null
      ? "Add your measurements above and your row lights up."
      : "Your baseline is <b>US "+esc(base)+"</b> — the median of what every brand here that publishes a US equivalent says about your measurements. Individual brands still differ, which is the whole reason the finder above reads each chart separately.")+
    '</p>';
}

function renderChartTable(prod,out,best){
  var d=prod.dims[0];
  $("charttable").innerHTML=
    '<p class="ctl">'+(out.driftN
      ? "The brand publishes the left column. The right is what bodies reported."
      : "The brand's chart, untouched. The right column moves the moment a review lands.")+'</p>'+
    '<table class="ct"><thead><tr><th>Size</th><th>'+d.label+' — chart</th><th>'+d.label+' — real</th></tr></thead><tbody>'+
    prod.sizes.map(function(s){
      var c=out.cap[d.k][s];
      var ch=c&&c.chart!=null?showDim(d,c.chart):"—";
      var rv=c&&c.val!=null?showDim(d,c.val):"—";
      var diff=(c&&c.chart!=null&&c.val!=null)?c.val-c.chart:null;
      var mark=(diff!=null&&Math.abs(diff)>=0.15)
        ? ' <span class="'+(diff<0?"dn":"up")+'">'+(diff>0?"+":"")+(Math.round(diff*10)/10)+'</span>' : "";
      return '<tr'+(s===best.size?' class="pick"':'')+'><td>'+esc(s)+'</td>'+
             '<td class="thin">'+ch+'</td><td>'+rv+mark+'</td></tr>';
    }).join("")+'</tbody></table>';
}

function renderReviews(){
  var prod=PRODUCTS[active], list=reviews[prod.id].slice().reverse();
  $("revkick").textContent = prod.demo ? "SAMPLE DATA" : "REAL PEOPLE. REAL FITS.";
  $("demobanner").innerHTML = prod.demo
    ? '<div class="demoban"><b>These reviews are made up</b><p>' + esc(prod.name) +
      ' is a fictional product, and the ' + reviews[prod.id].filter(function(r){return !r.mine;}).length +
      ' fit reports under it were written to demonstrate how the engine learns — they are not real customers and not a real garment. Every other brand here starts empty and fills with real reviews only.</p></div>'
    : "";
  if(!list.length){
    $("revlist").innerHTML='<p class="emptyrev">No fit reports for '+esc(prod.name)+
      ' yet.<br>Yours would be the first — and the one that moves this brand off its published chart.</p>';
    return;
  }
  $("revlist").innerHTML=list.slice(0,8).map(function(r){
    var said=prod.dims.filter(function(d){return r.a[d.k];})
      .map(function(d){return d.label.toLowerCase()+" "+(r.a[d.k]<0?"tight":"loose");}).join(", ")||"fit as expected";
    var v=prod.dims.map(function(d){return r.a[d.k];}).filter(function(x){return x!=null;});
    var m=v.length?v.reduce(function(a,b){return a+b;},0)/v.length:0;
    var tag=m<=-.4?["Runs small","rgba(190,66,56,.14)","#A6382F"]
           :m>=.4?["Runs large","rgba(61,109,168,.14)","#2F5A8C"]
           :["True to size","rgba(107,128,119,.2)","#3E5C50"];
    var body = (prod.shoe||prod.id==="sneaker")
      ? ftin(r.h)+" · foot "+showIn(r.foot)+" "+WIDTHW[r.width]
      : ftin(r.h)+(r.wt==null?"":" · "+(met()?Math.round(r.wt/LB_KG)+" kg":r.wt+" lb"))+" · bust "+showIn(r.bust);
    return '<div class="rev"><span class="mono" style="background:'+hashColor(r.u)+'">'+
      esc(r.u[0].toUpperCase())+'</span><div class="rb">'+
      '<span class="who">'+esc(r.u)+(r.mine?" (you)":"")+'</span>'+
      '<div class="stats">'+esc(body)+' · took '+esc(r.worn)+'</div>'+
      '<span class="tag" style="background:'+tag[1]+';color:'+tag[2]+'">'+tag[0]+'</span>'+
      '<p class="txt">'+esc(r.note||said)+'</p></div></div>';
  }).join("");
}

function renderRevForm(){
  var prod=PRODUCTS[active];
  if(!me){
    $("revform").innerHTML='<p class="sub" style="margin:0">Save your measurements above and the review form appears here — it is four taps, because we already have your body.</p>';
    return;
  }
  $("revform").innerHTML=
    '<h3 style="font-size:19px;font-weight:500;margin-bottom:4px">Leave a review</h3>'+
    '<p class="sub" style="font-size:13.5px">Your measurements attach themselves. No photo, ever.</p>'+
    '<label for="rv-size" style="margin-top:10px">Size you took</label>'+
    '<select id="rv-size">'+prod.sizes.map(function(s){return '<option>'+esc(s)+'</option>';}).join("")+'</select>'+
    '<label style="margin-top:12px">How did it fit?</label>'+
    prod.dims.map(function(d){
      return '<div class="arow"><span>'+d.label+'</span><div class="chips" data-dim="'+d.k+'">'+
        '<button data-v="-1">Tight</button><button data-v="0" aria-pressed="true">Right</button>'+
        '<button data-v="1">Loose</button></div></div>';
    }).join("")+
    '<label for="rv-note" style="margin-top:10px">In your words</label>'+
    '<textarea id="rv-note" placeholder="Fits true to size, comfortable through the shoulders."></textarea>'+
    '<button class="btn" id="rv-post" style="margin-top:12px">Post my review</button>';

  var draft={};
  prod.dims.forEach(function(d){ draft[d.k]=0; });
  Array.prototype.forEach.call($("revform").querySelectorAll(".chips"),function(row){
    Array.prototype.forEach.call(row.querySelectorAll("button"),function(b){
      b.onclick=function(){
        draft[row.dataset.dim]=+b.dataset.v;
        Array.prototype.forEach.call(row.querySelectorAll("button"),function(x){
          x.setAttribute("aria-pressed", x===b);
        });
      };
    });
  });

  $("rv-post").onclick=function(){
    var note=$("rv-note").value.trim();
    if(!note){ toast("Add a sentence about how it fit."); return; }
    var rec={u:"you",mine:true,worn:$("rv-size").value,a:draft,note:note,
             h:me.h,wt:(me.wt==null?null:Math.round(me.wt)),cup:me.cup||undefined};
    prod.dims.forEach(function(d){ rec[d.k]=me[d.k]; });
    if(prod.shoe||prod.id==="sneaker") rec.width=me.width;
    reviews[prod.id].push(rec);
    saveReviews();
    render(); renderReviews(); renderRevForm();
    toast("Posted. The recommendation just moved.");
  };
}

load();
if(me && me.sys && $("p-sys")) $("p-sys").value = me.sys;
applyUnits();
paintCat();
if(me){ show("result"); render(); } else { show("setup"); }
renderReviews(); renderRevForm();
})();
